import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburgermin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.89 2.813H2.11a.141.141 0 0 0-.141.14v1.125c0 .077.063.14.14.14h13.782a.14.14 0 0 0 .14-.14V2.953a.141.141 0 0 0-.14-.14Zm0 10.968H2.11a.141.141 0 0 0-.141.14v1.126c0 .077.063.14.14.14h13.782a.14.14 0 0 0 .14-.14v-1.125a.141.141 0 0 0-.14-.14Zm0-5.484H2.11a.141.141 0 0 0-.141.14v1.126c0 .077.063.14.14.14h13.782a.14.14 0 0 0 .14-.14V8.437a.141.141 0 0 0-.14-.14Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgHamburgermin);
export { ForwardRef as ReactComponent };
